module.exports = __webpack_public_path__ + "img/constant-learner.b81045ea.svg";